import { Config } from './types'

export const promos: Config = [
  {
    theatricalSlug: 'sketch',
    items: [
      {
        code: 'PREMIUM_GUILD',
        promoType: 'premium_guild',
        banner: {
          bannerType: 'custom_code',
          name: 'SketchGuildBanner',
        },
        modal: null,
      },
      {
        code: 'NOFEES',
        promoType: 'no_fees',
        banner: {
          bannerType: 'no_fees',
          backgroundImage: { src: '/v1754677627/sketch/sketch-bg-sky-01', width: 800, height: 449 },
          foregroundImage: { src: '/v1754677625/sketch/sketch-bg-sky-w-dave-02b', width: 640, height: 360 },
          accentColor: '#FF0068',
        },
        modal: {
          modalType: 'no_fees',
          backgroundImage: { src: '/v1754677627/sketch/sketch-bg-sky-01', width: 800, height: 449 },
          accentColor: '#FF0068',
        },
      },
      {
        code: 'PREMIUM_GUILD',
        promoType: 'premium_guild',
        banner: {
          bannerType: 'custom_code',
          name: 'SketchGuildBanner',
        },
        modal: null,
      },
    ],
  },
  {
    theatricalSlug: 'senior',
    items: [
      {
        code: 'SENIORXLAST-RODEO',
        promoType: 'custom',
        banner: {
          bannerType: 'custom_image',
          desktopImage: {
            src: '/v1755051597/senior/Senior_Presale-Engine-GFX_Banners_TLR_v12120x280',
            width: 2120,
            height: 280,
          },
          tabletImage: {
            src: '/v1755051598/senior/Senior_Presale-Engine-GFX_Banners_TLR_v11032x280',
            width: 1032,
            height: 280,
          },
          mobileImage: {
            src: '/v1755051596/senior/Senior_Presale-Engine-GFX_Banners_TLR_v1792x280',
            width: 792,
            height: 280,
          },
        },
        modal: null,
      },
      {
        code: 'SENIORXGREEN-AND-GOLD',
        promoType: 'custom',
        banner: {
          bannerType: 'custom_image',
          desktopImage: {
            src: '/v1755111675/senior/Senior_Presale-Engine-GFX_Banners_GAG_v12120x280',
            width: 2120,
            height: 280,
          },
          tabletImage: {
            src: '/v1755111674/senior/Senior_Presale-Engine-GFX_Banners_GAG_v2_1032x280',
            width: 1032,
            height: 280,
          },
          mobileImage: {
            src: '/v1755111675/senior/Senior_Presale-Engine-GFX_Banners_GAG_v2_792x280',
            width: 792,
            height: 280,
          },
        },
        modal: null,
      },
      {
        code: 'AARP',
        promoType: 'custom',
        banner: {
          bannerType: 'custom_image',
          desktopImage: {
            src: '/v1756234222/senior/Senior_Creative-Coalition_Banners_AARP-BOGO_2120x280_Desktop',
            width: 2120,
            height: 280,
          },
          tabletImage: {
            src: '/v1756234222/senior/Senior_Creative-Coalition_Banners_AARP-BOGO_1032x280_Tablet',
            width: 1032,
            height: 280,
          },
          mobileImage: {
            src: '/v1756234222/senior/Senior_Creative-Coalition_Banners_AARP-BOGO_792x280_Mobile',
            width: 792,
            height: 280,
          },
        },
        modal: null,
      },
      {
        code: 'BLUESTAR',
        promoType: 'custom',
        banner: {
          bannerType: 'custom_image',
          desktopImage: {
            src: '/v1756234349/senior/Senior_Creative-Coalition_Banners_Vets-Free_2120x280_Desktop',
            width: 2120,
            height: 280,
          },
          tabletImage: {
            src: '/v1756234349/senior/Senior_Creative-Coalition_Banners_Vets-Free_1032x280_Tablet',
            width: 1032,
            height: 280,
          },
          mobileImage: {
            src: '/v1756234349/senior/Senior_Creative-Coalition_Banners_Vets-Free_792x280_Mobile',
            width: 792,
            height: 280,
          },
        },
        modal: null,
      },
      {
        code: 'BYUSENIOR',
        promoType: 'custom',
        banner: {
          bannerType: 'custom_image',
          desktopImage: {
            src: '/v1757100579/senior/Senior_Banners_BYU_Discount_Senior_Creative-Coalition_Banners_AARP-BOGO_2120x280_Desktop',
            width: 2120,
            height: 280,
          },
          tabletImage: {
            src: '/v1757100579/senior/Senior_Banners_BYU_Discount_Senior_Creative-Coalition_Banners_AARP-BOGO_1032x280_Tablet',
            width: 1032,
            height: 280,
          },
          mobileImage: {
            src: '/v1757100579/senior/Senior_Banners_BYU_Discount_Senior_Creative-Coalition_Banners_AARP-BOGO_792x280_Mobile',
            width: 792,
            height: 280,
          },
        },
        modal: null,
      },
      {
        code: 'SENIORSGOFREE',
        promoType: 'custom',
        banner: {
          bannerType: 'custom_image',
          desktopImage: {
            src: '/v1757109684/senior/2120x280Angel_-_Senior_-_Web-Banners_-_Seniors-Go-Free_-2',
            width: 2120,
            height: 280,
          },
          tabletImage: {
            src: '/v1757109684/senior/1032x280Angel_-_Senior_-_Web-Banners_-_Seniors-Go-Free_-',
            width: 1032,
            height: 280,
          },
          mobileImage: {
            src: '/v1757109684/senior/792x280Angel_-_Senior_-_Web-Banners_-_Seniors-Go-Free_-',
            width: 792,
            height: 280,
          },
        },
        modal: null,
      },
      {
        code: 'NCS',
        promoType: 'custom',
        banner: {
          bannerType: 'custom_image',
          desktopImage: {
            src: '/v1757345893/senior/Angel_-_Senior_-_NCS-Banners_-_Group-Discount2120x280_2',
            width: 2120,
            height: 280,
          },
          tabletImage: {
            src: '/v1757345894/senior/Angel_-_Senior_-_NCS-Banners_-_Group-Discount1032x280_2',
            width: 1032,
            height: 280,
          },
          mobileImage: {
            src: '/v1757345893/senior/Angel_-_Senior_-_NCS-Banners_-_Group-Discount792x280_2',
            width: 792,
            height: 280,
          },
        },
        modal: null,
      },
      {
        code: 'EARLYBIRD',
        promoType: 'early_bird',
        banner: {
          bannerType: 'early_bird',
          backgroundImage: { src: '/v1755197737/senior/the-senior-football-chalkboard-bg', width: 800, height: 533 },
          foregroundImage: { src: '/v1755197736/senior/the-senior-mike-transparent', width: 220, height: 140 },
          accentColor: '#C41234',
          openingWeek: 'Sept 18 - Sept 26',
        },
        modal: {
          modalType: 'early_bird',
          backgroundImage: { src: '/v1755197737/senior/the-senior-football-chalkboard-bg', width: 800, height: 533 },
          accentColor: '#C41234',
          openingWeek: 'Sept 18 - Sept 26',
        },
      },
      {
        code: 'NO_FEES',
        promoType: 'no_fees',
        banner: {
          bannerType: 'no_fees',
          backgroundImage: { src: '/v1755197737/senior/the-senior-football-chalkboard-bg', width: 800, height: 533 },
          foregroundImage: { src: '/v1755197736/senior/the-senior-mike-transparent', width: 220, height: 140 },
          accentColor: '#C41234',
        },
        modal: {
          modalType: 'no_fees',
          backgroundImage: { src: '/v1755197737/senior/the-senior-football-chalkboard-bg', width: 800, height: 533 },
          accentColor: '#C41234',
        },
      },
      {
        code: 'PREMIUM_GUILD',
        promoType: 'premium_guild',
        banner: {
          bannerType: 'premium_guild',
        },
        modal: null,
      },
    ],
  },
  {
    theatricalSlug: 'truth-and-treason',
    items: [
      {
        code: 'SAVEBIG',
        promoType: 'early_bird',
        banner: {
          bannerType: 'early_bird',
          backgroundImage: { src: '/v1757378192/truth-and-treason/tnt-promo-background-2', width: 5428, height: 1520 },
          foregroundImage: { src: '/v1757375737/truth-and-treason/t_t-horizontal-poster', width: 249, height: 140 },
          accentColor: '#AE0009',
          openingWeek: 'Oct 18 - 22',
        },
        modal: {
          modalType: 'early_bird',
          backgroundImage: { src: '/v1757377431/truth-and-treason/tnt-modal-bg2', width: 1520, height: 1856 },
          accentColor: '#AE0009',
          openingWeek: 'Oct 18 - 22',
        },
      },
      {
        code: 'TNTXBONHOEFFER3',
        promoType: 'custom',
        banner: {
          bannerType: 'custom_image',
          desktopImage: {
            src: '/v1758913453/truth-and-treason/TT_Buy-3-Get-1_Banners-2120x280',
            width: 2120,
            height: 280,
          },
          tabletImage: {
            src: '/v1758913452/truth-and-treason/TT_Buy-3-Get-1_Banners-1032x280',
            width: 1032,
            height: 280,
          },
          mobileImage: {
            src: '/v1758913453/truth-and-treason/TT_Buy-3-Get-1_Banners-792x280',
            width: 792,
            height: 280,
          },
        },
        modal: null,
      },
      {
        code: 'TNTXBONHOEFFER4',
        promoType: 'custom',
        banner: {
          bannerType: 'custom_image',
          desktopImage: {
            src: '/v1758913591/truth-and-treason/TT_Buy-4-Get-1_Banners-2120x280',
            width: 2120,
            height: 280,
          },
          tabletImage: {
            src: '/v1758913592/truth-and-treason/TT_Buy-4-Get-1_Banners-1032x280',
            width: 1032,
            height: 280,
          },
          mobileImage: {
            src: '/v1758913590/truth-and-treason/TT_Buy-4-Get-1_Banners-792x280',
            width: 792,
            height: 280,
          },
        },
        modal: null,
      },
      {
        code: 'TRUTH',
        promoType: 'custom',
        banner: {
          bannerType: 'custom_image',
          desktopImage: {
            src: '/v1758923613/truth-and-treason/Truth_Treason_Teens_Go_Free_Banners_Use_Code_2180x280-Go_Free',
            width: 2120,
            height: 280,
          },
          tabletImage: {
            src: '/v1758923606/truth-and-treason/Truth_Treason_Teens_Go_Free_Banners_Use_Code_1032x280-Go_Free',
            width: 1032,
            height: 280,
          },
          mobileImage: {
            src: '/v1758923609/truth-and-treason/Truth_Treason_Teens_Go_Free_Banners_Use_Code_792x280-Go_Free',
            width: 792,
            height: 280,
          },
        },
        modal: null,
      },
    ],
  },
]
